export enum ContentSensitivity {
    SFW,
    NSFW,
    R18,
    R18G,

    UNCLASSIFIED
}
